import { useRouteLoaderData } from "react-router";
import posthog from "posthog-js";
import { $routeId } from "safe-routes";
import trackingEvents from "~/lib/trackingEvents";
import type { Template } from "~/models/templates.server";
import { TemplateCard } from "./TemplateCard";
import NotebookSequencingType from "app/schema/db/public/NotebookSequencingType";

export function NewNotebookModal({
  navigateToForTemplate,
  notebookSequencingType,
}: {
  navigateToForTemplate?: (template: Template) => string;
  notebookSequencingType?: NotebookSequencingType;
}) {
  const rootData = useRouteLoaderData<{ templates: Template[] }>($routeId("root"));
  const templates = rootData?.templates || [];

  return (
    <div className="flex flex-wrap gap-8 mt-4 justify-center">
      {templates
        .filter((template) =>
          notebookSequencingType ? template.sequencingType === notebookSequencingType : true,
        )
        .map((template) => (
          <TemplateCard
            key={template.id}
            notebook={template}
            navigateTo={navigateToForTemplate?.(template)}
            onSubmit={() => {
              posthog.capture(trackingEvents.cta_footer_choose_template, {
                notebook_id: template.id,
              });
            }}
          />
        ))}
    </div>
  );
}
